<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3 class="mb-4">Whatsapp Chats</h3>
        <highcharts v-if="chatChart" :options="chatChart"></highcharts>
        <v-card :loading="loading" class="mt-4">
          <v-card-text>
            <v-row class="px-3">
              <v-col cols="4">
                <v-text-field
                  v-model="data.name"
                  label="Chat name"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="data.primaryClassification"
                  v-model="selectedPrimaryClassification"
                  label="Primary Classification"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="data.secondaryClassification"
                  v-model="selectedSecondaryClassification"
                  label="Secondary Classification"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="hasMessages"
                  label="Show only if messages in last 7 days"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="Object.keys(search).length > 0" @click="clearSearch">
              Clear Search</v-btn
            >
            <v-btn @click="submitSearch"> Search</v-btn>
          </v-card-actions>
          <v-card-text v-if="chats.edges && chats.edges.length > 0">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Jid</th>
                  <th class="text-left">Primary Classification</th>
                  <th class="text-left">Secondary Classification</th>
                  <th class="text-left">Last Message</th>
                  <th class="text-left"># Messages Previous Day</th>
                  <th class="text-left"># Messages Previous Week</th>
                  <th class="text-left"># Pics Previous Day</th>
                  <th class="text-left"># Pics Previous Week</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="chatNode in chats.edges" :key="chatNode.node.id">
                  <td>
                    <a @click="openModal(chatNode.node)"
                      >{{ chatNode.node.name }}
                    </a>
                  </td>
                  <td>{{ chatNode.node.jid }}</td>
                  <td>{{ chatNode.node.primaryClassification }}</td>
                  <td>{{ chatNode.node.secondaryClassification }}</td>
                  <td>
                    {{
                      chatNode.node.lastMessageTimestamp
                        ? $moment(chatNode.node.lastMessageTimestamp).format(
                            "YYYY-MM-DD HH:mm"
                          )
                        : ""
                    }}
                  </td>
                  <td>{{ chatNode.node.previousDayMessageCount }}</td>
                  <td>{{ chatNode.node.previousWeekMessageCount }}</td>
                  <td>{{ chatNode.node.previousDayPicCount }}</td>
                  <td>{{ chatNode.node.previousWeekPicCount }}</td>
                </tr>
              </tbody>
            </v-simple-table>

            <div class="d-flex justify-center mt-4">
              <v-btn v-if="pageInfo.hasNextPage" @click="navigateNext"
                >Load More</v-btn
              >
            </div>
          </v-card-text>
          <v-card-text v-else>
            <v-alert type="info">
              Sorry there are no records which match your search
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-if="modal.show"
      v-model="modal.show"
      width="1200"
      transition="dialog-bottom-transition"
      class="limited-height"
    >
      <chat-messages :chat="selectedChat" @close="closeModal()"></chat-messages>
    </v-dialog>
  </v-container>
</template>

<script>
import { CHATS_QUERY, CHAT_HISTORY } from "../../constants/graphql/chat/chat";
import ChatMessages from "@/components/client/blocks/communication/ChatMessages";
import MetricMixin from "@/components/shared/mixins/MetricMixin";

const chatData = {
  name: "",
  primaryClassification: ["1-1", "CHALLENGES", "LIFE"],
  secondaryClassification: [
    "PRIVATE",
    "COACHES",
    "ACCOUNTABILITY",
    "NOTIFICATION",
    "SUBURB",
    "SPECIAL_INTEREST",
    "INSTRUCTOR_CREW",
    "LIFE_COMMUNITY",
  ],
};
const pageInfoData = {
  hasNextPage: null,
  hasPreviousPage: null,
  startCursor: null,
  endCursor: null,
};
export default {
  mixins: [MetricMixin],
  components: {
    ChatMessages,
  },
  data: () => ({
    chats: [],
    loading: true,
    selectedChat: null,
    modal: {
      show: false,
    },
    selectedPrimaryClassification: null,
    selectedSecondaryClassification: null,
    data: { ...chatData },
    search: {},
    pageInfo: { ...pageInfoData },
    hasMessages: false,
    chatChart: null,
    oneOnOneCount: [],
    challengeCount: [],
    lifeCount: [],
    totalCount: [],
    unclassifiedCount: [],
  }),
  methods: {
    navigateNext() {
      this.submitSearch(this.pageInfo.endCursor);
      window.scrollTo(0, 0);
    },
    openModal(chat) {
      this.selectedChat = chat;
      this.modal.show = true;
    },
    closeModal() {
      this.modal.show = false;
    },
    submitSearch(after = null) {
      let filter = {};
      this.loading = true;
      if (this.data.name) {
        filter["name"] = this.data.name;
      }
      if (this.selectedPrimaryClassification) {
        filter["primaryClassification"] = this.selectedPrimaryClassification;
      }
      if (this.selectedSecondaryClassification) {
        filter[
          "secondaryClassification"
        ] = this.selectedSecondaryClassification;
      }
      if (after) {
        filter["after"] = after;
      }
      if (this.hasMessages) {
        filter["hasMessages"] = this.hasMessages;
      }
      this.search = filter;
    },
    clearSearch() {
      (this.data = { ...chatData }), (this.pageInfo = { ...pageInfoData });
      this.selectedPrimaryClassification = null;
      this.selectedSecondaryClassification = null;
      this.hasMessages = false;
      this.submitSearch();
    },
  },
  apollo: {
    chats: {
      query: CHATS_QUERY,
      variables() {
        return this.search;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.pageInfo = response.data.chats.pageInfo;
          this.loading = false;
        }
      },
    },
    chatHistory: {
      query: CHAT_HISTORY,
      variables() {
        return {
          dateFrom: this.$moment()
            .subtract(this.startDays, "days")
            .format("YYYY-MM-DD"),
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.oneOnOneCount = [];
          this.challengeCount = [];
          this.lifeCount = [];
          this.totalCount = [];
          this.unclassifiedCount = [];

          response.data.chatHistory.forEach((row) => {
            this.oneOnOneCount.push(row.oneOnOneCount);
            this.challengeCount.push(row.challengeCount);
            this.lifeCount.push(row.lifeCount);
            this.totalCount.push(row.totalCount);
            this.unclassifiedCount.push(row.unclassifiedCount);
          });

          const commonChartOptions = {
            title: {
              text: "",
            },
            plotOptions: {
              series: {
                pointPlacement: "on",
              },
            },
            credits: {
              enabled: false,
            },
          };

          this.chatChart = {
            ...commonChartOptions,
            chart: {
              type: "line",
            },
            yAxis: {
              title: {
                text: "",
              },
            },
            xAxis: {
              categories: this.shortDates,
            },
            series: [
              {
                name: "1-1 Messages",
                data: this.oneOnOneCount,
                color: "orange",
              },
              {
                name: "Challenge Messages",
                data: this.challengeCount,
                color: "yellow",
              },
              {
                name: "Life Messages",
                data: this.lifeCount,
                color: "pink",
              },
              {
                name: "All Messages",
                data: this.totalCount,
                color: "green",
              },
              {
                name: "Unclassified Messages",
                data: this.unclassifiedCount,
                color: "cyan",
              },
            ],
          };
        }
      },
    },
  },
};
</script>
